import { Button, Form, Input, message, Select } from 'antd';
import { get } from 'lodash';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkPickedSerialSim, reserveNumber } from 'src/api/connection';
import { useAppSelector } from 'src/redux/hook';
import { ConnectionType, EnterpriseActiveTermConfigType } from 'src/shared/enum/connection.enum';
import { PickedSerialSim } from 'src/shared/interface/connection';
import { formatPhoneNumberV2 } from 'src/utils';
import { simTypeToText } from 'src/utils/sim.enum';
import { getStatusEsimLotTxt } from '../../../../pages/management/esimManagement/utils';
import ModalConfirmConnect from '../../ModalConfirmConnect';
import ModalReChooseNumber from '../../ModalReChooseNumber';
import { usePermission } from 'src/hooks/usePermission';
import ModalConfirmTerms from '../../ModalConfirmTems';

const ConnectionEnterprise = () => {
  const { masterData } = useAppSelector((state) => state.global);
  const { listPackageType } = useAppSelector((state) => state.global);

  const [serialNumber, setSerialNumber] = useState('');
  const [simMode, setSimMode] = useState();
  const [optionsSimMode, setOptionsSimMode] = useState([]);
  const [simData, setSimData] = useState<PickedSerialSim>();
  const [isVerify, setIsVerify] = useState<boolean>(false);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');
  const [currNumber, setCurrNumber] = useState<string>();
  const [isOpenNumberModal, setIsOpenNumberModal] = useState<boolean>(false);
  const [isOpenConnectModal, setIsOpenConnectModal] = useState<boolean>(false);
  const [isOpenTermsModal, setIsOpenTermsModal] = useState<boolean>(false);
  const [selectedTerms, setSelectedTerms] = useState<string[]>([]);
  const [_, setIsLoading] = useState<boolean>(false);
  const [isConnectFail, setIsConnectFail] = useState<boolean>(false);
  const navigate = useNavigate();

  const { hasPermission, PERMISSIONS } = usePermission();

  const handleCancel = () => {
    setIsOpenNumberModal(false);
  };

  const handleCancelConnectModal = () => {
    setIsOpenConnectModal(false);
    if (isConnectFail) {
      handleReset();
    }
  };
  const handleCancelTermsModal = () => {
    setIsOpenTermsModal(false);
  };

  const handleConfirmTerms = (terms: string[]) => {
    setSelectedTerms(terms);
    setIsOpenConnectModal(true);
  };

  const handleReset = async () => {
    setIsLoading(true);
    try {
      await reserveNumber({
        phoneNumber: currNumber,
        pool: simData?.pool,
        shopCode: simData?.shopCode,
        subType: simData?.subType,
        channelSim: simData?.channelSim,
      });

      navigate(0);
    } catch (error) {
      console.log(error);
    } finally {
      navigate(0);
    }
  };

  const handleCheckSerial = async () => {
    if (!serialNumber || serialNumber.length < 16 || !!simData || isVerify) {
      return;
    }

    setIsVerify(true);

    try {
      const respon = await checkPickedSerialSim({
        distributorId: JSON.parse(merchantInfo as string)?.merchantId,
        serialNumber: serialNumber,
      });

      if (respon) {
        setSimData(respon);
        setCurrNumber(respon?.phoneNumber);
        if (respon.availableSimModes) {
          const _optionsSimMode = respon.availableSimModes.map(
            (mode: { code: string; name: string }) => ({
              label: mode.name,
              value: mode.code,
            }),
          );
          setOptionsSimMode(_optionsSimMode);
          setSimMode(_optionsSimMode[0]?.value);
        } else {
          setOptionsSimMode([]);
          setSimMode(undefined);
        }
        setIsVerify(false);
      }
    } catch (error: any) {
      setIsVerify(false);
    }
  };

  const handleInputChange = (e: any) => {
    if (e.target.value.length <= 20) {
      setSerialNumber(e.target.value);
    } else {
      setSerialNumber(e.target.value.substring(0, 20));
    }
    e.preventDefault();
  };

  const renderSubType = (subType?: string) => {
    if (subType) {
      const objectSubType = masterData?.subType?.find((item: any) => {
        return item?.description === subType;
      });
      if (objectSubType) {
        return get(objectSubType, 'name', subType);
      } else {
        return subType;
      }
    } else {
      return subType;
    }
  };

  const handleOk = async (selectedNumber: string) => {
    try {
      setIsOpenNumberModal(false);
      setIsLoading(true);

      const response = await reserveNumber({
        phoneNumber: currNumber,
        pool: simData?.pool,
        shopCode: simData?.shopCode,
        subType: simData?.subType,
        channelSim: simData?.channelSim,
      });

      if (response) {
        setCurrNumber(selectedNumber);
      }
    } catch (error) {
      message.error('Đá số thất bại , xin vui lòng thử lại!');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBtnReChooseClick = () => {
    setIsOpenNumberModal(true);
  };

  console.log('🚀 ~ ConnectionEnterprise ~ simData:', simData);
  return (
    <>
      <div className='flex flex-col gap-5 mb-6'>
        <div className='flex items-center flex-wrap gap-3'>
          <Form.Item
            name='serialNumber'
            label={<span className='font-semibold'>Số SIM serial</span>}
            className='my-0'
            rules={[
              {
                min: 16,
                message: 'Vui lòng nhập đủ số serial',
              },
            ]}
          >
            <Input
              type='number'
              maxLength={20}
              onChange={(e) => handleInputChange(e)}
              onKeyDown={(evt: any) => {
                if (!evt.ctrlKey && !evt.metaKey) {
                  if (
                    evt.key === 'e' ||
                    evt.key === '+' ||
                    evt.key === '-' ||
                    (!isFinite(Number(evt.key)) && evt.key !== 'Backspace') ||
                    Number(evt.key) > 9 ||
                    Number(evt.key) < 0
                  ) {
                    evt.preventDefault();
                  } else if (evt.target.value?.length >= 20 && evt.key !== 'Backspace') {
                    evt.preventDefault();
                  }
                }
              }}
              disabled={!!simData}
              onPressEnter={handleCheckSerial}
              style={{ minWidth: '200px' }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type='primary'
              onClick={handleCheckSerial}
              disabled={
                !serialNumber ||
                serialNumber.length < 16 ||
                !!simData ||
                isVerify ||
                !hasPermission(PERMISSIONS.CONNECTION.SINGLE_CHECK_SERIAL)
              }
            >
              Kiểm tra
            </Button>
          </Form.Item>
        </div>
        {simData && (
          <>
            <div className='flex flex-col gap-4 md:flex-row md:items-center md:gap-10'>
              <div className='my-0 font-semibold'>
                Loại:{' '}
                <span className='font-normal'>{simData && simTypeToText(simData?.simType)}</span>
              </div>
              <div className='my-0 font-semibold'>
                NPP: <span className='font-normal'>{simData?.distributorName}</span>
              </div>
              {hasPermission(PERMISSIONS.CONNECTION.SINGLE_PERSONAL_CHECK_STATUS) && (
                <div className='my-0 font-semibold'>
                  Trạng thái:{' '}
                  <span className='font-normal'>
                    {simData?.status && getStatusEsimLotTxt(simData?.status?.toString())}
                  </span>
                </div>
              )}
            </div>
            <div className='m-0 flex flex-col gap-4 md:flex-row md:items-center md:gap-10 flex-wrap'>
              <div className='my-0 font-semibold'>
                Tên gói: <span className='font-normal'>{simData?.mbfName}</span>
              </div>
              <div className='my-0 font-semibold'>
                Loại gói:{' '}
                <span className='font-normal'>
                  {listPackageType?.find((item) => item.description === simData?.packageType)
                    ?.name ?? 'Gói thường'}
                </span>
              </div>
            </div>
            <div className='m-0 flex flex-col gap-4 md:flex-row md:items-center md:gap-10 flex-wrap'>
              <div className='my-0 md:min-w-[300px] flex gap-2 font-semibold items-center'>
                Hình thức SIM:{' '}
                <Select
                  options={optionsSimMode}
                  placeholder='Chọn hình thức SIM'
                  value={simMode}
                  onChange={(value) => setSimMode(value)}
                  className='min-w-[200px]'
                />
              </div>
            </div>
            <div className='m-0 flex flex-col gap-4 md:flex-row md:items-center md:gap-10 flex-wrap'>
              <div className='my-0 md:min-w-[300px] flex gap-2 md:gap-0'>
                <span className='block md:min-w-[150px] font-semibold'>Số thuê bao: </span>
                <span>{currNumber && formatPhoneNumberV2(currNumber)}</span>
              </div>
              <div className='my-0 md:min-w-[300px] flex gap-2 md:gap-0'>
                <span className='block md:min-w-[150px] font-semibold'>Loại thuê bao: </span>
                <span>
                  {simData?.subType
                    ? renderSubType(simData?.subType)
                    : masterData?.subType?.find((item: any) => item?.description === 'AZ2')?.name}
                </span>
              </div>
              {simData?.kindOfSim !== 'PhoneNumberOnSim' &&
                hasPermission(PERMISSIONS.CONNECTION.SINGLE_PERSONAL_RESELECT_NUMBER) && (
                  <Button onClick={handleBtnReChooseClick}>Chọn lại số</Button>
                )}
            </div>
            <div className='flex gap-5 my-5'>
              <Button
                type='primary'
                onClick={() => {
                  if (
                    masterData.activeTermsConfig &&
                    masterData.activeTermsConfig.find(
                      (t: any) => t.name === EnterpriseActiveTermConfigType.ActiveSingle,
                    ).description === 'ON'
                  ) {
                    setIsOpenTermsModal(true);
                  } else {
                    setIsOpenConnectModal(true);
                  }
                }}
              >
                Đấu nối
              </Button>
              <Button onClick={handleReset}>Làm mới</Button>
            </div>
          </>
        )}
      </div>
      <ModalReChooseNumber
        isOpen={isOpenNumberModal}
        onCancel={handleCancel}
        onOk={handleOk}
        pool={simData?.pool}
        shopCode={simData?.shopCode}
        subType={simData?.subType}
        channelSim={simData?.channelSim}
        custType={simData?.custType}
      />
      <ModalConfirmTerms
        isOpen={isOpenTermsModal}
        handleCancel={handleCancelTermsModal}
        onConfirm={handleConfirmTerms}
      />
      <ModalConfirmConnect
        isOpen={isOpenConnectModal}
        handleCancel={handleCancelConnectModal}
        setIsConnectFail={setIsConnectFail}
        connectionType={ConnectionType.ENTERPRISE}
        terms={selectedTerms}
        userProfile={{
          createdBy: JSON.parse(merchantInfo as string)?.merchantName,
        }}
        phoneInfo={{
          phoneNumber: currNumber || '',
          serialNumber: serialNumber,
          pool: simData?.pool || 0,
          distributorId: JSON.parse(merchantInfo as string)?.merchantId,
          mbfCode: simData?.mbfCode || '',
          simType: simData?.simType,
          kindOfSim: simData?.kindOfSim,
          subType: simData?.subType,
          shopCode: simData?.shopCode,
          channelSim: simData?.channelSim,
          packageType: simData?.packageType,
          parentId: simData?.parentId,
          promCode: simData?.promCode,
          simMode,
        }}
      />
    </>
  );
};

export default ConnectionEnterprise;
